import { dateShortOut } from 'Simple/Data/format.js'
import { phone, capitalize } from 'Data/format.js'

let KNOWN_ANSWER_KEYS = new Set([
  'patient.firstName',
  'patient.lastName',
  'patient.dateOfBirth',
  'patient.email',
  'patient.gender',
  'patient.phoneDetails',
  'patient.contactDetails',
  'patient.address',
  'patient.heardAboutUs',
  'responsiblePerson',
  'responsiblePersonFirstName',
  'responsiblePersonFirstName',
  'responsiblePersonLastName',
  'responsiblePersonEmail',
  'responsiblePersonAddress',
  'responsiblePersonPhoneDetails',
  'responsiblePersonContactDetails',
  'responsiblePersonRelationship',
  'insurance',
  'location',
  'appointment',
  'imagecapture',
])

function formatName(value) {
  return (
    value &&
    value
      .trim()
      .split(' ')
      .map(part => capitalize(part))
      .join(' ')
  )
}

export function getData({ value, images = [], questions }) {
  // remap to known external resource_ids
  let answers = {}
  questions.forEach(question => {
    if (
      value.answers[question.id] !== null &&
      value.answers[question.id] !== undefined
    ) {
      answers[
        question.resource_id && KNOWN_ANSWER_KEYS.has(question.resource_id)
          ? question.resource_id
          : question.id
      ] =
        value.answers[question.id]?.skipped === true
          ? '-'
          : value.answers[question.id]
    }
  })

  return {
    person:
      (answers['patient.firstName'] && {
        firstName: formatName(answers['patient.firstName']),
        lastName: formatName(answers['patient.lastName']),
        birthDate: dateShortOut(answers['patient.dateOfBirth']),
        email:
          answers['patient.email'] ||
          answers['patient.contactDetails']?.emailDetails?.emailAddress,
        gender: answers['patient.gender']?.value,
        address: answers['patient.address'],
        heardAboutUs: answers['patient.heardAboutUs'],
        phoneDetails: {
          type:
            answers['patient.phoneDetails']?.phoneType.toUpperCase() ||
            answers[
              'patient.contactDetails'
            ]?.phoneDetails?.phoneType.toUpperCase(),
          number:
            phone(answers['patient.phoneDetails']?.phoneNumber) ||
            phone(answers['patient.contactDetails']?.phoneDetails?.phoneNumber),
        },
        optins: {
          phone: {
            agreeOnMarketing:
              answers['patient.phoneDetails']?.allowNotifications ||
              (answers['patient.contactDetails']?.selected?.allowMarketing &&
                answers['patient.contactDetails']?.selected
                  ?.allowMarketingMethod !== 'email'),
            agreeOnConsent:
              answers['patient.phoneDetails']?.allowConsent ||
              (answers['patient.contactDetails']?.selected?.allowMarketing &&
                answers['patient.contactDetails']?.selected
                  ?.allowMarketingMethod !== 'email'),
          },
          email: {
            agreeOnMarketing:
              answers['patient.phoneDetails']?.allowNotifications ||
              (answers['patient.contactDetails']?.selected?.allowMarketing &&
                answers['patient.contactDetails']?.selected
                  ?.allowMarketingMethod !== 'phone'),
            agreeOnConsent:
              answers['patient.phoneDetails']?.allowConsent ||
              (answers['patient.contactDetails']?.selected?.allowMarketing &&
                answers['patient.contactDetails']?.selected
                  ?.allowMarketingMethod !== 'phone'),
          },
        },
      }) ||
      null,
    responsible:
      answers?.responsiblePerson?.value === 'patient'
        ? null
        : (answers.responsiblePersonFirstName && {
            firstName: formatName(answers.responsiblePersonFirstName),
            lastName: formatName(answers.responsiblePersonLastName),
            email:
              answers?.responsiblePersonEmail ||
              answers?.responsiblePersonContactDetails?.emailDetails
                ?.emailAddress,
            address: answers.responsiblePersonAddress,
            phoneDetails: {
              type:
                answers?.responsiblePersonPhoneDetails?.phoneType.toUpperCase() ||
                answers?.responsiblePersonContactDetails?.phoneDetails?.phoneType.toUpperCase(),
              number:
                phone(
                  answers?.responsiblePersonContactDetails?.phoneDetails
                    ?.phoneNumber
                ) || phone(answers?.responsiblePersonPhoneDetails?.phoneNumber),
            },
            optins: {
              phone: {
                agreeOnMarketing:
                  answers['responsiblePersonPhoneDetails']
                    ?.allowNotifications ||
                  (answers['responsiblePersonContactDetails']?.selected
                    ?.allowMarketing &&
                    answers['patient.contactDetails']?.selected
                      ?.allowMarketingMethod !== 'email'),
                agreeOnConsent:
                  answers['responsiblePersonPhoneDetails']?.allowConsent ||
                  (answers['responsiblePersonContactDetails']?.selected
                    ?.allowMarketing &&
                    answers['responsiblePersonContactDetails']?.selected
                      ?.allowMarketingMethod !== 'email'),
              },
              email: {
                agreeOnMarketing:
                  answers['responsiblePersonPhoneDetails']
                    ?.allowNotifications ||
                  (answers['responsiblePersonContactDetails']?.selected
                    ?.allowMarketing &&
                    answers['responsiblePersonContactDetails']?.selected
                      ?.allowMarketingMethod !== 'phone'),
                agreeOnConsent:
                  answers['responsiblePersonPhoneDetails']?.allowConsent ||
                  (answers['responsiblePersonContactDetails']?.selected
                    ?.allowMarketing &&
                    answers['responsiblePersonContactDetails']?.selected
                      ?.allowMarketingMethod !== 'phone'),
              },
            },
            relationshipType:
              answers.responsiblePersonRelationship?.value.toUpperCase(),
          }) ||
          null,
    insurance: answers?.insurance?.value.toUpperCase(),
    location: answers?.location || {},
    appointment: answers?.appointment || {},
    images,
    answers: Object.entries(answers)
      .filter(([key, value]) => {
        if (KNOWN_ANSWER_KEYS.has(key) || value?.image) return false

        let question = questions.find(question => question.id === key)
        if (!question) return false

        return !question.isInformationOnly
      })
      .map(([key, value]) => {
        let question = questions.find(question => question.id === key)
        let resource = question.resource
        if (!resource) return { answer: value, id: key }

        if (resource.type === 'referral') {
          resource = {
            ...resource,
            id: question.options.find(option => option.text === value.text)
              ?.internalId,
          }
        }

        return {
          resource,
          answer: value,
          id: key,
        }
      }),
  }
}
